//我的证书
import request from '../utils/request';
//获取证书列表
export function toMyCertList(data) {
  return request({
    url: '/wap/learning/toMyCertList.do',
    method: 'post',
    data
  })
}
//查看证书
export function getCertDetail(data) {
  return request({
    url: '/wap/learning/getCertDetail.html',
    method: 'post',
    data
  })
}




